module.exports = __webpack_public_path__ + "static/lekker-game-chef-og-82592fa357900b817b894264b74317c6.jpg";